module.exports = __webpack_public_path__ + "static/img/定制开发1.12762211.png";